import { useQuery } from '@tanstack/react-query';
import { getDeliveryByPoNumber } from '../api/receiving-client';

export function useDeliveryByPO(poNumber: string | undefined) {
  return useQuery({
    queryKey: ['delivery', 'by-po', poNumber],
    queryFn: () => getDeliveryByPoNumber(poNumber as string),
    enabled: Boolean(poNumber),
    staleTime: 30_000,
    retry: 1,
  });
}
